import { render, staticRenderFns } from "./AdminHospitalPatientInputList.vue?vue&type=template&id=62f818e6&scoped=true"
import script from "./AdminHospitalPatientInputList.vue?vue&type=script&lang=js"
export * from "./AdminHospitalPatientInputList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f818e6",
  null
  
)

export default component.exports